import Sentry from '@/services/sentry'
import UserAPI from '@/api/user'

const getters = {
  isSlideOptionAutocompleteEnabled: (_, __, rootState) => {
    return rootState.currentUser.userSetting.isSlideOptionAutocompleteEnabled
  },
  scimEnabled: (_, __, rootState, rootGetters) => {
    return rootState.currentUser.isScimEnabled && rootGetters['featureToggles/canUseSCIM']
  },
  isOnDemandAIEnabled: (_, __, rootState) => {
    return rootState.currentUser.userSetting?.isOnDemandAIEnabled ?? true
  },
  isAutomaticAIEnabled: (_, __, rootState) => {
    return rootState.currentUser.userSetting?.isAutomaticAIEnabled ?? true
  },
}
const actions = {
  setIsSlideOptionAutocompleteEnabledAction: async ({ commit }, isSlideOptionAutocompleteEnabled) => {
    try {
      UserAPI.setUserSetting({ isSlideOptionAutocompleteEnabled })
      commit('setUserSetting', {
        isSlideOptionAutocompleteEnabled,
      }, { root: true })
    } catch (e) {
      Sentry.captureException(e)
    }
  },
  setIsOnDemandAIEnabledAction: async ({ commit, dispatch }, isOnDemandAIEnabled) => {
    try {
      await UserAPI.setUserSetting({ isOnDemandAIEnabled })
      commit('setUserSetting', { isOnDemandAIEnabled }, { root: true })
      await dispatch('featureSettings/fetchFeatureSettings', null, { root: true })
    } catch (e) {
      Sentry.captureException(e)
    }
  },
  setIsAutomaticAIEnabledAction: async ({ commit, dispatch }, isAutomaticAIEnabled) => {
    try {
      await UserAPI.setUserSetting({ isAutomaticAIEnabled })
      commit('setUserSetting', { isAutomaticAIEnabled }, { root: true })
      await dispatch('featureSettings/fetchFeatureSettings', null, { root: true })
    } catch (e) {
      Sentry.captureException(e)
    }
  },
}

const userSettings = {
  namespaced: true,
  getters,
  actions,
}

export default userSettings
